import e from "@dialpad/dialtone-tokens/layered/themes/tokens-brick-colors.css?inline";
//#region themes/brick.js
var t = {
	brand: {
		css: e,
		name: "brick"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
